import styled from "styled-components"

export const Container = styled.div`
  width: 100%;
  min-height: 20rem;
  position: relative;
`

export const RefreshContainer = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  display: flex;
`
